// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"

// ** ThemeConfig Import
import ThemeConfig from "@configs/themeConfig"

const initialMenuCollapsed = () => {
  const item = window.localStorage.getItem("menuCollapsed")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : ThemeConfig().themeConfig.layout.menu.isCollapsed
}

const initialDirection = () => {
  const item = window.localStorage.getItem("direction")
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : ThemeConfig().themeConfig.layout.isRTL
}

// El rediseño no contempla modo oscuro y el toggle del navbar se retiró, así que el
// skin queda fijo en el de themeConfig ("light"). Se limpia cualquier valor guardado
// por una sesión anterior: si quedara "dark", Vuexy seguiría aplicando dark-layout.scss
// sobre unos tokens que solo están definidos en claro, y el resultado es un tema a medias.
const initialSkin = () => {
  const configured = ThemeConfig().themeConfig.layout.skin
  const stored = window.localStorage.getItem("skin")

  if (stored && JSON.parse(stored) !== configured) {
    window.localStorage.removeItem("skin")
  }

  return configured
}

export const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    skin: initialSkin(),
    isRTL: initialDirection(),
    layout: ThemeConfig().themeConfig.layout.type,
    lastLayout: ThemeConfig().themeConfig.layout.type,
    menuCollapsed: initialMenuCollapsed(),
    footerType: ThemeConfig().themeConfig.layout.footer.type,
    navbarType: ThemeConfig().themeConfig.layout.navbar.type,
    menuHidden: ThemeConfig().themeConfig.layout.menu.isHidden,
    contentWidth: ThemeConfig().themeConfig.layout.contentWidth,
    navbarColor: ThemeConfig().themeConfig.layout.navbar.backgroundColor
  },
  reducers: {
    handleRTL: (state, action) => {
      state.isRTL = action.payload
      window.localStorage.setItem("direction", JSON.stringify(action.payload))
    },
    handleSkin: (state, action) => {
      state.skin = action.payload
      window.localStorage.setItem("skin", JSON.stringify(action.payload))
    },
    handleLayout: (state, action) => {
      state.layout = action.payload
    },
    handleFooterType: (state, action) => {
      state.footerType = action.payload
    },
    handleNavbarType: (state, action) => {
      state.navbarType = action.payload
    },
    handleMenuHidden: (state, action) => {
      state.menuHidden = action.payload
    },
    handleLastLayout: (state, action) => {
      state.lastLayout = action.payload
    },
    handleNavbarColor: (state, action) => {
      state.navbarColor = action.payload
    },
    handleContentWidth: (state, action) => {
      state.contentWidth = action.payload
    },
    handleMenuCollapsed: (state, action) => {
      state.menuCollapsed = action.payload
      window.localStorage.setItem(
        "menuCollapsed",
        JSON.stringify(action.payload)
      )
    }
  }
})

export const {
  handleRTL,
  handleSkin,
  handleLayout,
  handleLastLayout,
  handleMenuHidden,
  handleNavbarType,
  handleFooterType,
  handleNavbarColor,
  handleContentWidth,
  handleMenuCollapsed
} = layoutSlice.actions

export default layoutSlice.reducer
